import React from 'react';

interface BreadcrumbProps {
  path: string[]; // e.g., ['Gallery'] or ['Gallery', 'Favorites']
  onNavigate: (index: number) => void; // Called with index of clicked breadcrumb
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ path, onNavigate }) => {
  return (
    <div className="flex items-center space-x-2 text-sm mb-6">
      {path.map((segment, index) => (
        <React.Fragment key={index}>
          {index > 0 && (
            <svg
              className="w-4 h-4 text-gray-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          )}
          <button
            onClick={() => onNavigate(index)}
            className={`font-medium transition-colors ${
              index === path.length - 1
                ? 'text-gray-900 cursor-default'
                : 'text-blue-600 hover:text-blue-800 hover:underline'
            }`}
            disabled={index === path.length - 1}
          >
            {segment}
          </button>
        </React.Fragment>
      ))}
    </div>
  );
};

export default Breadcrumb;
